<template>
  <div>
    <VCard
      v-for="(preset,index) in presets"
      :key="index"
      @click="onClick(preset)"
      class="preset-list-item mb-1 mb-md-3 pa-2 pa-md-4"
      :outlined="$vuetify.breakpoint.mdAndUp"
      elevation="0"
    >
      <div class="d-flex align-baseline flex-column flex-md-row">
        <div class="mb-1 mb-md-0" :class="{ 'step-subtitle': $vuetify.breakpoint.mdAndUp }">
          {{ preset.title }}
        </div>
        <WizardCounts class="ml-md-auto mb-0" short :questions="preset.counts.questions" />
      </div>
    </VCard>
  </div>
</template>

<script>
import WizardCounts from '@/components/Vacancy/WizardCounts';

export default {
  name: 'VacancyPresetsList',
  components: { WizardCounts },
  props: {
    presets: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      activePreset: true,
    };
  },
  methods: {
    onClick(preset) {
      this.$emit('select', { ...preset, activePreset: this.activePreset });
    },
  },
};
</script>

<style lang="scss" scoped>
  .preset-list-item {
    transition: all 0.1s ease-in;

    &:hover {
      border-color: #4EB4FF;
      color: #0A82D9;
    }
  }
  .preset-title {
    font-size: 18px;
    line-height: 30px;
  }
</style>
